import React from 'react';
import classNames from 'classnames';

import './Button.scss';

const Button = ({
  title,
  type = 'button',
  sizeSM,
  sizeMD,
  span = false,
  buttonClassName,
  onClick,
}) => {
  return (
    <button
      className={classNames('Button', buttonClassName, { 'Button--sm': sizeSM }, { 'Button--md': sizeMD })}
      type={type}
      onClick={onClick}
    >
      {title}
      {span && <span />}
    </button>
  );
};

export default Button;